import { Helmet } from "react-helmet-async";
export default function SEO({
  title,
  description,
  name,
  type,
  canonicalUrl,
  keywords,
  image,
  twitterHandle,
}: {
  title: string;
  description: string;
  name: string;
  type: string;
  canonicalUrl: string;
  keywords: string;
  image: string;
  twitterHandle: string;
}) {
  return (
    <Helmet>
      {/* === Standard SEO === */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={name} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonicalUrl} />

      {/* === Open Graph (Facebook, WhatsApp, LinkedIn, etc.) === */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Nombre de tu sitio" />

      {/* === Twitter Card === */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:creator" content={twitterHandle} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
